<template>
    <div :title="$options.filters.list(selectedValues)">
      <div ref="input" class="dropdown-selection" :class="{'disabled': disabled}" @click.stop="toggle">
        <span class="label placeholder" v-if="isEmpty && !searchingText && placeholder">{{$t(placeholder)}}</span>

        <!-- show selected options -->
        <template>
          <template v-if="tags">
            <ul class="tags">
              <li class="selection" v-for="item in selectedItems">
                <span class="remove-btn" @click.stop="onRemoveItemClick(item.id)">×</span>
                {{item.name}}
              </li>
              <li class="search-input">
                <!-- livesearch enabled-->
                <input ref="search"
                       class="search"
                       :style="{'width': (1.03 * searchingText.length) + 'em'}"
                       v-model="searchingText"
                       @click.self.prevent
                       v-if="livesearch">
              </li>
            </ul>
          </template>

          <span class="label selected" v-else-if="!isEmpty && !searchingText">
            <span>{{selectedValues | list}}</span>
          </span>
          <!-- adds additional row when no placeholder and there is a selected item-->
          <span class="label" v-if="!livesearch"></span>
        </template>

        <!-- livesearch enabled-->
        <input ref="search"
               class="a-input search"
               v-model="searchingText"
               @click.self.prevent
               v-if="livesearch && !tags">

        <b class="button">
          <img class="selectric-img-button" src="@/assets/img/static/vector-arrow.svg" alt="">
        </b>
      </div>

      <div ref="options" style="display:none">
        <slot>
        </slot>
      </div>

      <div ref="dropdownList">
        <div class="dropdown-list"
             :class="{'dropdown-list-shown': isVisible}"
             :style="dropdownListStyle"
             @mouseenter="isMouseOver = true"
             @mouseleave="isMouseOver = false">
          <div class="dropdown-scroll">
            <ul>
              <li class="helper" v-if="searching">Поиск...</li>
              <li class="helper" v-else-if="availableOptions.length === 0">Совпадений не найдено</li>

              <li :class="{'selected': isSelected(item), 'disabled': item.disabled}"
                  :key="item.id"
                  v-for="item in availableOptions"
                  @click="onItemClick(item.id)"
                  v-if="!searching">
                <span :class="{['level-' + item.level] : true}">{{item.name}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    props: {
      options: {
        type: Array
      },

      disabled: {
        type: Boolean,
        default: false
      },

      searching: {
        type: Boolean,
        default: false
      },

      multiple: {
        type: Boolean,
        default: false
      },

      tags: {
        type: Boolean,
        default: false
      },

      livesearch: {
        type: Boolean,
        default: false
      },

      value: {
        type: [Array, String, Number, Object, Boolean]
      },

      placeholder: {
        type: String
      }
    },

    data: () => ({
      inlineOptions: undefined,
      isVisible: false,
      isMouseOver: false,
      dropdownListStyle: undefined,
      searchingText: ''
    }),

    filters: {
       list(value) {
        return value.join('; ')
      }
    },

    computed: {
      availableOptions() {
        return [].concat(this.inlineOptions||[], this.options||[]).map(e => ({
          ...e,
          name: this.$t(e.name)
        }))
      },

      selectedItems() {
        if (_.isArray(this.value)) {
          return [...this.value];
        }
        else if (this.value !== undefined) {
          return [ this.value ];
        }
        else {
          return [];
        }
      },

      isEmpty() {
        return this.selectedValues.length === 0;
      },

      selectedValues() {
        if (this.livesearch || this.tags) {
          // if livesearch is used, value may contain options which are not in the list
          //   so value is array of object { id, value }
          return this.selectedItems.map(e => e.name);
        }
        else {
          // here value is array or single ids
          const values = this.selectedItems.map(e => _.get(_.find(this.availableOptions, { id : e.valueOf() }), 'name'));
          return values;
        }
      }
    },

    watch: {
      searchingText(value) {

        if (this._queryTimer) {
          clearTimeout(this._queryTimer);
        }

        this._queryTimer = setTimeout(() => {
          this.$emit('query', value);
        }, 700);
      },

      // '$i18n.locale'() {
      //   console.info('detected locale change');
      //   this._checkInlineOptions();
      // }
    },

    mounted() {
      this._checkInlineOptions();

      const dropdownListNode = this.$refs.dropdownList;
      if (dropdownListNode) {
        dropdownListNode.parentNode.removeChild(dropdownListNode);
      }
    },

    beforeDestroy() {
      this.dispose();
    },

    methods: {
      _checkInlineOptions() {
        const options = Array.prototype.map.call(this.$refs.options.querySelectorAll('option') || [], (e) => ({
          id: (e.value !== "" ? e.value : undefined),
          disabled: e.disabled,
          name: e.text || e.label
        }));

        if (options.length > 0) {
          this.inlineOptions = options;
        }
      },

      _updatePosition() {
        const bounds = this.$refs.input.getBoundingClientRect();
        this.dropdownListStyle = {
          top: (window.scrollY || window.pageYOffset || 0) + bounds.top + bounds.height + 'px',
          left: (window.scrollX || window.pageXOffset || 0) + bounds.left + 'px'
        };
      },

      isSelected(item) {
        return _.find(this.selectedItems, e => _.get(e, 'id', e) == item.id) !== undefined;
      },

      onItemClick(id) {
        let item = this.availableOptions.find(e => _.get(e, 'id') == id);

        if (!!item.disabled) {
          return
        }

        if (this.livesearch || this.tags) {
          const selectedItem = {...item};

          let value;

          if (this.multiple) {
            value = this.value || [];
            value.push(selectedItem);
          }
          else {
            value = selectedItem;
          }

          this.$emit('input', value);
          this.$emit('change', value);
        }
        else if (this.multiple) {
          let items = this.selectedItems;

          if (_.isUndefined(item.id)) {
            items = [];
          }
          else if (this.isSelected(item)) {
            const idx = _.findIndex(items, e => _.get(e, 'id', e) == item.id);
            items.splice(idx, 1);
          }
          else {
            items.push(item.id);
          }

          this.$emit('input', items);
          this.$emit('change', items);
        }
        else {
          this.$emit('input', item.id);
          this.$emit('change', item.id);
        }

        this.searchingText = '';
        this.hide();
      },

      onRemoveItemClick(id) {
        const value = _.cloneDeep(this.value || []);
        const idx = _.findIndex(value, { id });

        if (idx !== -1) {
          value.splice(idx, 1);
          this.$emit('input', value);
          this.$emit('change', value);
        }
      },

      toggle() {
        if (!this.isVisible) {
          this.show()
        }
        else {
          this.hide()
        }
      },

      show() {
        if (this.isVisible || this.disabled) return;

        // this.dispose();

        this.isVisible = true;
        this._updatePosition();

        if (!this._mounted) {
          const node = document.body.appendChild(this.$refs.dropdownList);
          this._mounted = `dropdown-wrapper-${Date.now() + Math.random()}`;
          node.id = this._mounted;
        }

        this._onClickOutside = () => {
          if (!this.isMouseOver) {
            this.hide();
          }
        };

        this._onEscKeyPress = (event) => {
          if (event.keyCode === 27) {
            this.hide()
          }
        };

        window.addEventListener('click', this._onClickOutside);
        window.addEventListener('keydown', this._onEscKeyPress);
        window.addEventListener('resize', this._updatePosition);

        if (this.$refs.search) {
          this.$refs.search.focus();
        }
      },

      hide() {
        if (!this.isVisible) return;

        window.removeEventListener('click', this._onClickOutside);
        window.removeEventListener('keydown', this._onEscKeyPress);
        window.removeEventListener('resize', this._updatePosition);
        this.searchingText = '';
        this.isVisible = false;
      },

      dispose() {
        this.hide();

        if (this._mounted) {
          const node = document.getElementById(this._mounted);
          node && node.parentNode.removeChild(node);
          this._mounted = false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .dropdown-selection {
    border: 1px solid #e4e4e4;
    background: white;
    position: relative;
    border-radius: 5px;
    cursor: pointer;
    width: 100%;
    padding-right: 30px;
    text-align: left;

    &.disabled {
      filter: alpha(opacity=50);
      opacity: 0.5;
      cursor: default;
      user-select: none;
    }

    .label {
      display: inline-block;
      overflow: hidden;
      margin: 0 26px 0 0;
      padding: 3px 0 3px 12px;
      font-size: 18px;
      color: #666666;
      text-align: left;
      font-weight: 400;
      line-height: inherit;
      min-height: 34px;
      height: 100%;
      user-select: none;
    }

    .search {
      border: none!important;
      background: none!important;
      outline: none!important;
      display: inline-block;
      width: 100%;
      height: 100%;

      &.hidden {
        display: none!important;
      }
    }

  .placeholder {
    color: #B2B2B2;
    position: absolute;
    left: 0px;
    line-height: 17px;
    display: inline-flex;
    align-items: center;
  }

  .selected {
    position: absolute;
    left: 0px;
    line-height: 17px;
    display: inline-flex;
    align-items: center;
  }

  .button {
    display: block;
    position: absolute;
    right: 0;
    width: 30px;
    height: 30px;
    color: #BBB;
    text-align: center;
    line-height: 34px;
    font: 0/0 a;
    top: 0;
    height: 100%;

    img {
      position: relative;
      top: 14px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
    }
  }

    ul.tags {
      padding:  8px 0 8px 12px;
      display: inline-block;
      min-height: 34px;

      li {
        list-style: none;
        border: 0;
        cursor: default;
        float: left;
        margin-right: 5px;
        margin-top: 2px;
        font-size: 18px;

        &.selection {
          border-radius: 13px;
          background-color: #f2f2f2;
          padding: 4px 11px;
        }

        &.search-input {
          .search {
            min-width: 1em;
            box-sizing: content-box;
          }
        }

        &.empty {
          clear: both;
          float: none;
          padding: 0px;
        }

        .remove-btn {
          position: relative;
          top: -6px;
          display: inline-block;
          float: right;
          margin-left: 12px;
          height: 12px;
          color: #e30611;
          cursor: pointer;
          font-size: 27px;
          line-height: 10px;
          cursor: pointer;
          z-index: 20;
          top: 3px;
        }
      }
    }
  }

  .dropdown-list {
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    top: 100%;
    left: 0;
    background: #fff;
    border: 1px solid #cbcbcb;
    z-index: -1;
    box-shadow: 0 0 10px -6px;
    display: none;
    z-index: 9999;
    max-height: 250px;
    overflow-y: auto;

    &.dropdown-list-shown {
      display: block;
      position: absolute;
    }

    .dropdown-scroll {
      height: 100%;
      overflow: auto;

      ul {
        font-size: 16px;
        list-style: none;
        padding: 0;
        margin: 0;
        font-size: 18px;
        line-height: 20px;
        min-height: 20px;

        li {
          padding: 5px 24px 5px 12px;
          text-align: left;
          border-top: 1px solid #fff;
          border-bottom: 1px solid #eee;
          color: #333;
          font-size: 16px;
          cursor: pointer;
          display: block;
          list-style: none;
          margin: 0;
          line-height: 20px;
          min-height: 20px;

          &:hover {
            background: #f5f5f5;
          }

          &.selected {
            border-top-color: #e4e4e4;
            background: #f5f5f5;
            position: relative;

            &:before {
              position: absolute;
              right: 7px;
              transform: translate(0px, 25%);
              width: 14px;
              height: 14px;
              content: "";
              background: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSItMS40IC0xLjcgMTQgMTQiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgLTEuNCAtMS43IDE0IDE0IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCgk8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0UzMDYxMyIgZD0iTTEwLjYtMC43TDMsOC44TDAuNCw2LjVjMCwwLTEuNCwwLjEtMSwwLjVsMi45LDMuOWMwLjIsMC4yLDAuNCwwLjMsMC42LDAuM2MwLDAsMC4xLDAsMC4xLDAgYzAsMCwwLjEsMCwwLjEsMGMwLjQsMCwwLjctMC4yLDAuOS0wLjVsOC0xMUMxMi4yLTAuOCwxMC42LTAuNywxMC42LTAuN3oiLz4NCjwvc3ZnPg0K) no-repeat 0 0;
            }
          }

          &.helper {
            color: #666666;
            font-style: italic;
          }

          &.disabled {
            color: #666666;
            opacity: 0.5;
            background: inherit!important;
            cursor: default;
          }
        }
      }
    }
  }

  .table {
    .label {
      font-size: 13px;
      min-height: 23px;

      width: 100%;
      padding-right: 30px;

      span {
        text-overflow: ellipsis;

        /* Required for text-overflow to do anything */
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
</style>
